// src/application/use-cases/check-existing-game.use-case.ts
import { GameStage } from '#lib/domain/types.ts';
import type { GameRepository } from './game-repository.port';

export class CheckExistingGame {
	constructor(private readonly storage: GameRepository) {}

	execute(): boolean {
		const storedState = this.storage.restore();
		return !!storedState && storedState.gameStage !== GameStage.CHOOSE_INITIAL_DEITY;
	}
}
